import script from "./account.vue?vue&type=script&setup=true&lang=js"
export * from "./account.vue?vue&type=script&setup=true&lang=js"

import "./account.vue?vue&type=style&index=0&id=603dc6ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-603dc6ea"]])

export default __exports__